import styled from 'styled-components';
import { PrimaryButton } from '../../shared/sharedStyles.styles';

export default styled(PrimaryButton)`
  font-size: 12px;
  font-weight: 600;
  width: auto;
  min-width: auto;
  height: auto;
  padding: 9px 20px;
  margin-bottom: 10px;
  border: none;
  border-radius: 999px;
  color: #fff !important;
  background: linear-gradient(
    165deg,
    #ffc56b 0%,
    #ff9f2e 18%,
    #ff7200 45%,
    #e85d00 72%,
    #c44a00 100%
  ) !important;
  box-shadow:
    0 2px 8px rgba(255, 114, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.25);
  transition: filter 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;

  @media (max-width: 800px) {
    width: auto;
    height: auto;
    font-size: 12px;
  }

  &:hover {
    border: none !important;
    filter: brightness(1.05);
    box-shadow:
      0 4px 14px rgba(255, 114, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.3);
    transform: translateY(-1px);
    background: linear-gradient(
      165deg,
      #ffc56b 0%,
      #ff9f2e 18%,
      #ff7200 45%,
      #e85d00 72%,
      #c44a00 100%
    ) !important;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const PDFButton = styled(PrimaryButton)`
  font-size: 12px;
  font-weight: 500;
  width: auto;
  min-width: 5vw;
  height: auto;
  padding: .2vw;
  margin-bottom: 10px;
  margin-right: 5px;
  background-color: transparent;
  border: 1px solid #152b4e;
  color: #152b4e;

  &:hover {
    background-color: white;
    border: 1px solid #152b4e;
  }

  &:disabled {
    cursor: not-allowed;
  }
`;

export const ButtonEndWrapper = styled.div`
  position: relative;
  flex-shrink: 0;
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  z-index: 2;
`;

export const RequestButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  position: fixed;
  right: 20px;
  bottom: 30px;
  font-size: .8rem;
  margin-top: .5rem;
  z-index: 1;
  width: 45px;
  height: 45px;
  border-radius: 45px;

  ${({customstyle}) => customstyle}
`;
